const API_ENDPOINTS = {
  LOGIN: "admin/profile/login",
  USERLIST: "admin/user/list",
  USERDETAIL: "admin/user/details",
  TRANSLATION: "admin/translation",
  TRANSLATION_UPDATE: "admin/translation/update/bulk",
  WIRE_DETAILS: "admin/wire/details",
};

export default API_ENDPOINTS;